// extracted by mini-css-extract-plugin
export default {"photo-grid":"photo-grid--mp-lRMRp","photoGrid":"photo-grid--mp-lRMRp","placeholder-wrapper":"placeholder-wrapper--mp-KTWNT","placeholderWrapper":"placeholder-wrapper--mp-KTWNT"};